module.exports = __webpack_public_path__ + "img/banipv61branco.31b61193.png";